if (!customElements.get('announcement-countdown')) {
  customElements.define(
    'announcement-countdown',
    class AnnouncementCountdown extends HTMLElement {
      constructor() {
        super();
        this.endTime = new Date(this.dataset.end).getTime();
        this.expiredAction = this.dataset.expiredAction || 'hide';
        this.expiredText = this.dataset.expiredText || '';
        this.hideDaysWhenZero = this.dataset.hideDays === 'true';
        this.values = {
          days: this.querySelector('[data-unit="days"] [data-value]'),
          hours: this.querySelector('[data-unit="hours"] [data-value]'),
          minutes: this.querySelector('[data-unit="minutes"] [data-value]'),
          seconds: this.querySelector('[data-unit="seconds"] [data-value]'),
        };
        this.daysUnit = this.querySelector('[data-unit="days"]');
      }

      connectedCallback() {
        if (Number.isNaN(this.endTime)) {
          this.remove();
          return;
        }
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const remaining = this.endTime - Date.now();

        if (remaining <= 0) {
          this.onExpired();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.values.days.textContent = this.pad(days);
        this.values.hours.textContent = this.pad(hours);
        this.values.minutes.textContent = this.pad(minutes);
        this.values.seconds.textContent = this.pad(seconds);

        if (this.daysUnit) {
          this.daysUnit.hidden = this.hideDaysWhenZero && days === 0;
        }

        this.classList.add('announcement-countdown--ready');
      }

      onExpired() {
        clearInterval(this.interval);

        if (this.expiredAction === 'text' && this.expiredText) {
          this.innerHTML = '';
          const span = document.createElement('span');
          span.className = 'announcement-countdown__expired';
          span.textContent = this.expiredText;
          this.appendChild(span);
          this.classList.add('announcement-countdown--ready');
          return;
        }

        this.remove();
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }
    }
  );
}